import React, { Component } from "react";
import { get, isString } from "lodash";
import {
  dateFormat,
  isValidArray,
  getColor,
  getLocalstorage,
  replaceCharacterWith,
  daysLeft
} from "../../helper";
import { PreNode, ReadMore, RedirectUser } from "../reusableComponent";
import { connect } from "react-redux";
import attachmentIcon from "../../assets/attachment-icon.svg";
import { getTime } from "date-fns";

class MOMDesc extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getMeetingStatusColor = type => {
    const colorCode = {
      "under consideration": "state-color-orange",
      "under process": "state-color-purple",
      "under decision": "state-color-blue",
      "on hold": "state-color-yellow",
      hold: "state-color-yellow",
      "under verification": "state-color-juniper",
      verified: "state-color-green",
      duplicate: "state-color-orange",
      resolved: "state-color-green",
      juniper: "state-color-juniper",
      rejected: "state-color-red",
      reject: "state-color-red",
      "pending with rm/rs": "state-color-purple"
    };
    return colorCode[isString(type) && type.toLowerCase()] || "color-blue";
  };

  renderTasks = () => {
    const { meeting } = this.props;
    // console.log("meeting", meeting);
    const tasks = ["task1", "task2"];
    const renderedTasks = [];

    for (const task of tasks) {
      if (meeting[task]) {
        renderedTasks.push(
          <li key={task}>
            {meeting[task]}
            <p>
              Completion Date:{" "}
              <span>
                {(meeting[`${task}CompletionDate`] &&
                  dateFormat(meeting[`${task}CompletionDate`])) ||
                  "NA"}
              </span>
            </p>
          </li>
        );
      }
    }

    if (renderedTasks.length > 0) {
      return (
        <div className="issue-state issue-state">
          <ol className="ol-list">{renderedTasks}</ol>
        </div>
      );
    }

    return null;
  };

  render() {
    const { readMore, meeting, projectData, issueData, dataObj } = this.props;

    const latestDate = dataObj.reduce((maxDate, task) => {
      const taskDate =
        task.meetingId != null ? new Date(task.taskCompletionDate) : "";
      return taskDate > maxDate ? taskDate : maxDate;
    }, new Date(0));

    const meetingDecisionSub =
      dataObj &&
      dataObj.reduce((maxDate, task) => {
        const taskDate =
          task.meetingId != null ? new Date(task.decisionSubmittedOn) : "";
        return taskDate > maxDate ? taskDate : maxDate;
      }, new Date(0));

    let projectId = get(projectData, "data.id", null);
    let duplicateIssues = get(issueData, "data.duplicateIssues") || [];
    const userInfo = getLocalstorage("user");
    const isUserPMG = get(userInfo, "groupCategory") === "PMG";
    let data = get(issueData, "data", null);
    // console.log(data);
    const status = replaceCharacterWith(
      get(data, "issueStatusName", "NA"),
      "_",
      " "
    );

    return (
      <React.Fragment>
        <div className="mom-desc">
          <div className="d-flex flex-row justify-content-between align-items-center">
            {get(meeting, "meetingId") !== null ? (
              <h4>Minutes of Meeting</h4>
            ) : get(meeting, "meetingId") == null &&
              get(meeting, "issueStatus") == "Pending with SM" &&
              get(meeting, "recipientGroup") != null ? (
              <h4>Ministry Review Decision</h4>
            ) : (
              <h4>Decisions without Meeting</h4>
            )}
            {/* <h4>Minutes of Meeting</h4> */}
            {get(meeting, "meetingId") === null && (
              <div
                className={`${getColor(
                  get(meeting, "issueStatus", "").toLowerCase()
                )} decision-status-container unClickable`}
              >
                <p>{get(meeting, "issueStatus", "NA")}</p>
              </div>
            )}
          </div>
          <div className="mom-data">
            <p className="m-0">
              <PreNode classes="pre-node-decision">
                <span
                  className={`${
                    get(meeting, "meetingDescription").match(/[\u0900-\u097F]/)
                      ? "hindi-text-wrap-semi-bold issue-decision-scroll"
                      : ""
                  }`}
                >
                  {get(meeting, "meetingDescription", "NA")}
                </span>
                {/* <ReadMore
                  clamp={3}
                  content={get(meeting, "meetingDescription", "NA")}
                /> */}
              </PreNode>
            </p>
            {(isValidArray(get(meeting, "actionItemDTOList", [])) && (
              <div className="action-item-wrapper">
                <b>Action Items:</b>
                <ul>
                  {(get(meeting, "actionItemDTOList", null) || []).map(
                    (actionItem, index) => (
                      <li key={`${index}-li`}>
                        <label>
                          Assign to - {get(actionItem, "assignToName", "NA")} |
                          Target Completion Date -{" "}
                          {dateFormat(
                            get(actionItem, "completionDate", "NA")
                          ) || "Not decided yet"}
                        </label>
                        <span>{get(actionItem, "description", "NA")}</span>
                      </li>
                    )
                  )}
                </ul>
                {readMore ? <span className="read-more">Read Less</span> : ""}
              </div>
            )) ||
              null}
            {/* Condition is for Ministry Review Decision */}
            {// meeting &&
            //   meeting.issueStatus == "Pending with SM" &&
            //   get(meeting, "recipientGroup") == null &&
            (meeting &&
              meeting.issueStatus == "Pending with SM" &&
              get(meeting, "recipientGroup") == null) ||
              (meeting && meeting.issueStatus !== "Pending with SM" && (
                <div className="next-meeting-date">
                  <label>Issue Resolution Date:</label>{" "}
                  <span
                    className={
                      meeting.meetingDTO.id
                        ? new Date(meeting.taskCompletionDate) < new Date() &&
                          getTime(meeting.decisionSubmittedOn) ==
                            getTime(meetingDecisionSub) &&
                          meeting.taskCompletionDate &&
                          issueData.data.issueStatus !== "RESOLVED"
                          ? "date-overdue"
                          : ""
                        : ""
                    }
                  >
                    {(get(meeting, "taskCompletionDate") &&
                      dateFormat(get(meeting, "taskCompletionDate"))) ||
                      "NA"}
                  </span>
                  {issueData.data.issueStatus !== "RESOLVED" &&
                  getTime(meeting.decisionSubmittedOn) ==
                    getTime(meetingDecisionSub) &&
                  meeting.taskCompletionDate != null &&
                  meeting.meetingDTO.id ? (
                    new Date(meeting.taskCompletionDate).setHours(0, 0, 0, 0) <
                    new Date().setHours(0, 0, 0, 0) ? (
                      <span className="status-overdue">Overdue</span>
                    ) : new Date(meeting.taskCompletionDate).setHours(
                        0,
                        0,
                        0,
                        0
                      ) >= new Date().setHours(0, 0, 0, 0) ? (
                      <span className="delay-status">
                        {daysLeft(meeting.taskCompletionDate) == "1"
                          ? daysLeft(meeting.taskCompletionDate) + " Day left"
                          : daysLeft(meeting.taskCompletionDate) + " Days left"}
                      </span>
                    ) : (
                      " "
                    )
                  ) : (
                    ""
                  )}
                </div>
              ))}
            {this.renderTasks() && (
              <div>
                <div className="intermediate-tasks-wrapper">
                  <h4>Intermediate Tasks</h4>
                </div>
                <div className="issue-state-wrapper">{this.renderTasks()}</div>
              </div>
            )}

            <div className="agenda-decision-container">
              {isValidArray(get(meeting, "fileDTOList")) ? (
                <div className="attachmentsDetails">
                  <img
                    src={attachmentIcon}
                    alt="attachment icon"
                    className="mr-1 attachmentIcon"
                  />
                  <div className="meeting-attachments">
                    {get(meeting, "fileDTOList", []).map((val, index) => {
                      const extension = val.name.substr(
                        val.name.lastIndexOf(".") + 1,
                        val.name.length
                      );
                      return (
                        <>
                          <div className="momdesc_attachment">
                            <a
                              href={val.s3Url}
                              rel="noopener noreferrer"
                              target="_blank"
                            >
                              {/* {val.title} */}
                              {val.title && val.title.length > 20
                                ? val.title.substring(0, 20) + "..."
                                : val.title == null
                                ? val.name.substring(0, 20) + "..."
                                : val.title}
                              {/* {index < get(meeting, "fileDTOList", []).length - 1
                              ? `, <span>&nbsp;</span>`
                              : " "} */}
                              {index <
                              get(meeting, "fileDTOList", []).length - 1 ? (
                                <>
                                  {", "}
                                  <span style={{ whiteSpace: "pre" }}>
                                    {"\u00A0"}
                                  </span>
                                </>
                              ) : (
                                <> </>
                              )}
                              {/* &nbsp;{"  "}&nbsp; */}
                            </a>
                            <div class="attachment-added">
                              <div class="project-download-icons">
                                <div class="download-icons-pdf">
                                  {extension}
                                </div>
                                <a
                                  target="_blank"
                                  href={val.s3Url}
                                  download="Screenshot 2023-08-10 173004.png"
                                  rel="noopener noreferrer"
                                >
                                  {val.title}
                                </a>
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })}
                  </div>
                </div>
              ) : null}
              <div className="show-date-status d-flex ml-auto">
                {get(meeting, "decisionCreatedBy", "NA") == null ? (
                  <></>
                ) : (
                  <>
                    <div className="decision-submission-date">
                      <span class="issue-created-by verified-user" />
                      <span class="first-pp-name">
                        <span class="issue-creator-name  text-left">
                          <RedirectUser
                            title={get(meeting, "decisionCreatedBy", "NA")}
                            id={
                              isUserPMG == false
                                ? get(meeting, "decisionCreatedById", "NA")
                                : get(meeting, "decisionCreatedById", "NA")
                            }
                          />
                        </span>
                      </span>
                    </div>
                  </>
                )}

                <div
                  className={
                    get(meeting, "decisionCreatedBy", "NA") == null
                      ? null
                      : "decision-submission-date issue-id-wrapper decision-left-border"
                  }
                >
                  {/* Decision Submitted on :{" "} */}
                  {dateFormat(get(meeting, "decisionSubmittedOn", null))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    projectData: state.projectDetailsReducer.projectData,
    issueData: state.issueDetailsReducer.issueData
  };
}

export default connect(
  mapStateToProps,
  null
)(MOMDesc);
